__turbopack_context__.v({
  "badge": "glass-button-module__pzftEq__badge",
  "badgeCount": "glass-button-module__pzftEq__badgeCount",
  "fullWidth": "glass-button-module__pzftEq__fullWidth",
  "inner": "glass-button-module__pzftEq__inner",
  "label": "glass-button-module__pzftEq__label",
  "root": "glass-button-module__pzftEq__root",
  "section": "glass-button-module__pzftEq__section",
  "sizeLg": "glass-button-module__pzftEq__sizeLg",
  "sizeMd": "glass-button-module__pzftEq__sizeMd",
  "sizeSm": "glass-button-module__pzftEq__sizeSm",
  "skeleton": "glass-button-module__pzftEq__skeleton",
  "skeletonFullWidth": "glass-button-module__pzftEq__skeletonFullWidth",
  "skeletonLg": "glass-button-module__pzftEq__skeletonLg",
  "skeletonLgRadius": "glass-button-module__pzftEq__skeletonLgRadius",
  "skeletonMd": "glass-button-module__pzftEq__skeletonMd",
  "skeletonSm": "glass-button-module__pzftEq__skeletonSm",
  "wrapper": "glass-button-module__pzftEq__wrapper",
});
